module.exports = __webpack_public_path__ + "img/yfood-smooth-vanilla.9faab06c.png";